<template>
  <v-card elevation="0">
    <v-card-title>Derniers utilisateurs</v-card-title>
    <v-card-text>
      <template v-if="loading==false">
        <v-list dense>
          <v-list-item v-for="user in users" :key="user.id">
            <v-list-item-content>{{user.firstname}} {{user.lastname}} - {{user.account.name}}</v-list-item-content>
            <v-list-item-icon>
              <v-icon color="pink" x-small>mdi-circle</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    users: 0,
    loading: true
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.lastUsers()
        .then(data => {
          this.users = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ...mapActions("statistique", ["lastUsers"])
  }
};
</script>

<style>
</style>